import { Component } from "@angular/core";

@Component({
  selector: "app-template-questionnaire-list-page",
  templateUrl: "./template-questionnaire-list-page.component.html",
  styleUrls: ["./template-questionnaire-list-page.component.scss"],
})
export class TemplateQuestionnaireListPageComponent {}
